import { createFunctionUrl } from '@upcaret/supabase-types/client';

type AuthEmailerResponse = {
  message?: string;
  error?: string;
};

export async function sendAuthEmailer(
  action: string,
  payload: Record<string, unknown> & { turnstileToken?: string },
): Promise<AuthEmailerResponse> {
  const url = `${createFunctionUrl('auth-emailer')}/${action}`;
  const appId = requireAppId();
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      ...payload,
      action,
      appId,
    }),
  });

  let data: AuthEmailerResponse | null = null;
  try {
    data = await response.json();
  } catch {
    // ignore
  }

  if (!response.ok) {
    const message = data?.error || `Request failed (${response.status})`;
    throw new Error(message);
  }

  return data ?? {};
}

export function requestSignup(params: {
  email: string;
  password: string;
  redirectTo?: string;
  data?: Record<string, unknown>;
  turnstileToken?: string;
}) {
  return sendAuthEmailer('signup', params);
}

export function requestRecovery(params: {
  email: string;
  redirectTo?: string;
  turnstileToken?: string;
}) {
  return sendAuthEmailer('recovery', params);
}

export function requestMagicLink(params: {
  email: string;
  redirectTo?: string;
  turnstileToken?: string;
}) {
  return sendAuthEmailer('magic_link', params);
}

function requireAppId(): string {
  const appId = import.meta.env['VITE_APP_ID'];
  if (!appId) {
    throw new Error(
      'Missing app id. Set VITE_APP_ID to "cently" or "upcaret".',
    );
  }
  return appId;
}
